import urlJoin from 'url-join';
import axiosWrapper from 'axiosWrapper';
import {Lang} from 'contexts/LangContext';
import {Locale} from 'contexts/LocaleContext';
import {RouterData} from 'contexts/RouterContext';
import {CLOUD_TITLE} from '../constants';
import {getAbsoluteLocaleUrl} from '../../common/i18n/utils';

export function getCleanTitle(title?: string) {
    if (!title || !title.includes('|')) {
        return title;
    }

    const [cleanTitle] = title.split('|');

    return cleanTitle?.trim();
}

export function getDefaultTitle(sectionTitle?: string) {
    return sectionTitle ? `${CLOUD_TITLE} - ${getCleanTitle(sectionTitle)}` : CLOUD_TITLE;
}

export function getTitleTemplate(sectionTitle?: string) {
    return `%s | ${getDefaultTitle(sectionTitle)}`;
}

export function getMetaLocale(lang: Lang) {
    switch (lang) {
        case Lang.En:
            return 'en_US';
        default:
            return `${lang.toLowerCase()}_${lang.toUpperCase()}`;
    }
}

export function getSharingImageURL(
    locale: Locale,
    router: RouterData,
    withQuery = false,
    routePrefix?: string,
): string {
    const pagePath = urlJoin(
        '/image-generator',
        routePrefix ?? '',
        router.pathname,
        withQuery
            ? `?${new URLSearchParams(router.query as Record<string, string>).toString()}`
            : '',
    );
    const url = getAbsoluteLocaleUrl(locale, router.hostname, pagePath);
    const config = {
        url: `https://${router.hostname}/api/image-generator/generate`,
        params: {
            url,
            width: 1280,
            height: 640,
        },
    };
    return axiosWrapper.getUri(config);
}

export function getCSRFToken() {
    if (__IS_SERVER__) {
        return '';
    }

    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
}
